module.exports = __webpack_public_path__ + "static/media/Edit.d40640f0.svg";